/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { SearchIcon, X } from "lucide-react";
import { Fragment } from "react";
import { InputBox } from "./input-box";

type Props = {
  list: string[];
  manageList: (prop: any) => void;
  search: string;
  placeholder: string;
  itemText: string;
  error: string | undefined;
  bulkEdit: boolean;
};

export const ArrayList = ({
  list,
  manageList,
  search,
  placeholder,
  itemText,
  error,
  bulkEdit,
}: Props) => {
  return (
    <Fragment>
      <div className=" mt-2  max-h-[300px]  overflow-y-auto border relative border-slate-200 rounded-md ">
        <div className="sticky bg-white px-2 py-3 top-0 hidden z-[1] left-0 right-0">
          <div className="relative bg-white">
            <SearchIcon
              className="absolute left-3 top-3 text-slate-600"
              size={16}
            />
            <Input
              value={search}
              onChange={(e) =>
                manageList({
                  type: "search",
                  payload: { data: e.target.value },
                })
              }
              type="search"
              placeholder="Search..."
              className="pl-9"
            />
          </div>
        </div>
        <div className="px-2 pt-2 pb-1">
          {list?.map((item: string, index: number) => {
            const isVisible = item
              ?.toLowerCase()
              .includes(search?.toLowerCase());
            return (
              <div
                key={index}
                className={cn(
                  " mr-3 mb-2 items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground",
                  isVisible ? "inline-flex" : "hidden"
                )}
                onClick={() =>
                  manageList({ type: "edit", payload: { index, data: item } })
                }
              >
                <span className="px-2">{item}</span>
                <Button
                  className="p-0 h-auto"
                  variant="ghost"
                  type="button"
                  onClick={() =>
                    manageList({ type: "remove", payload: { index } })
                  }
                >
                  <X size={12} />
                </Button>
              </div>
            );
          })}

          <InputBox
            placeholder={placeholder}
            manageList={manageList}
            itemText={itemText}
            error={error}
            bulkEdit={bulkEdit}
          />
        </div>
      </div>
    </Fragment>
  );
};
